module.exports = __webpack_public_path__ + "media/images/common/header_logo-6f8c7a6648f2c626056d1e1f97bf6b78.png";